import { useConsoleState } from '@/lib/voice-console/state/context'
import type { AssistantStatus } from '@/lib/voice-console/state/types'
import { cn } from '@/lib/utils'

function glowColor(status: AssistantStatus): string {
  switch (status) {
    case 'disconnected': return 'bg-slate-800'
    case 'connecting': return 'bg-amber-500/60'
    case 'idle': return 'bg-cyan-600/60'
    case 'listening': return 'bg-cyan-400/80'
    case 'processing': return 'bg-indigo-400/80'
    case 'tool_use': return 'bg-violet-400/80'
    case 'speaking': return 'bg-pink-400/80'
    case 'error': return 'bg-red-500/80'
    default: return 'bg-slate-800'
  }
}

function isAnimating(status: AssistantStatus): boolean {
  return ['connecting', 'processing', 'tool_use', 'speaking', 'listening'].includes(status)
}

export function GlowLine() {
  const { state } = useConsoleState()
  const { assistantStatus } = state
  return (
    <div
      className={cn(
        'h-px w-full shrink-0 transition-colors duration-500',
        glowColor(assistantStatus),
        isAnimating(assistantStatus) && 'animate-pulse'
      )}
    />
  )
}
